
export default {
  props: ['curso_name', 'curso_id'],
  data() {
    return {
      cursos: [],
      activeCurso: 0,
      panel: null,
      loaded: false,
      modalPreco: false,
    }
  },
  computed: {
    curso: (v) => v.cursos[v.activeCurso],
    preco: (v) =>
      v.curso?.investimento?.filter(
        (c) => c?.forma && c?.forma === 'cartão'
      )[0],
  },
  
  watch: {
    $route: '$fetch',
    activeCurso() {
      this.panel = null
    },
  },
  
  async fetch() {
    this.loaded = false

    let api = this.$nuxt.$config.API_URL
    await this.$nuxt.$http
      .$get(`${api}/api/cursos-technos?categoria=${this.curso_id}`)
      .then((res) => {
        this.cursos = res
        this.loaded = true
      })
  },
}
